<template>
	<div class="origin-page">
		<!-- 左侧：行情 / 大脑列表 -->
		<aside class="origin-side">
			<div class="origin-group">
				<div class="origin-group-title">行情中心</div>
				<template v-for="item in marketList">
					<!-- 可展开下拉分组 -->
					<div v-if="item.children" :key="'group-' + item.name">
						<div class="origin-nav-item origin-group-toggle" :class="{ active: isGroupActive(item) }"
							@click="toggleGroup(item)">
							<span>{{ item.name }}</span>
							<span class="origin-arrow" :class="{ open: item.expanded }"></span>
						</div>
						<div class="origin-sub-items" v-show="item.expanded">
							<div class="origin-nav-item origin-sub-item" v-for="sub in item.children" :key="sub.name"
								:class="{ active: current === sub }" @click="selectItem(sub)">
								{{ sub.name }}
							</div>
						</div>
					</div>
					<!-- 普通叶子项 -->
					<div v-else :key="'item-' + item.name" class="origin-nav-item" :class="{ active: current === item }"
						@click="selectItem(item)">
						{{ item.name }}
					</div>
				</template>
			</div>

			<div class="origin-group">
				<div class="origin-group-title">产业大脑</div>
				<div class="origin-sub-group" v-for="group in brainGroups" :key="group.name">
					<div class="origin-sub-title">{{ group.name }}</div>
					<div class="origin-nav-item" v-for="item in group.items" :key="item.name"
						:class="{ active: current === item }" @click="openUrl(item)">
						{{ item.name }}
					</div>
				</div>
			</div>
		</aside>

		<!-- 右侧：内嵌页面 / 自定义子页面 -->
		<main class="origin-main">
			<component v-if="current && current.custom" :is="current.custom" :key="current.name" @nav="handleNav" />
			<iframe v-else-if="current && isEmbeddable(current.url)" class="origin-frame" :src="current.url"
				frameborder="0" allowfullscreen></iframe>
			<div class="origin-empty" v-else>功能建设中，敬请期待</div>
		</main>
	</div>
</template>

<script>
	import AgriIndex200 from './marketPrice/AgriIndex200.vue'
	import NewsInfo from './marketPrice/NewsInfo.vue'
	import PriceIndex from './marketPrice/PriceIndex.vue'
	import PriceQuote from './marketPrice/PriceQuote.vue'
	import AnalysisReport from './marketPrice/AnalysisReport.vue'

	export default {
		components: { AgriIndex200, NewsInfo, PriceIndex, PriceQuote, AnalysisReport },
		data() {
			return {
				// 行情中心：叶子项直接渲染；带 children 的为可展开下拉分组
				marketList: [
					// custom 标记为本地子组件（非 iframe）；行情总览即原首页仪表盘，置于行情中心首位
					{ name: '行情总览', custom: 'AgriIndex200' },
					{ name: '价格指数', custom: 'PriceIndex' },
					{ name: '价格行情', custom: 'PriceQuote' },
					{ name: '辣椒行情', url: 'https://qg.18yimu.com/shopsheet/index.html' },
					{ name: '产品行情', url: 'https://qg.18yimu.com/shopprice/index.html' },
					{ name: '期货行情', url: 'https://qg.18yimu.com/shopfutureRecord/index.html' },
					{ name: '新闻资讯', custom: 'NewsInfo' },
					{ name: '分析报告', custom: 'AnalysisReport' },
				],
				// 产业大脑（按子分组）
				brainGroups: [
					{
						name: '肉类',
						items: [
							{ name: '夔州肉兔产业大脑', url: 'https://kzrtdn.18yimu.com/new/#/' }
							// { name: '生猪产业大脑（荣昌猪）', url: '#' }
						]
					},
					{
						name: '种植类',
						items: [
							{ name: '双堡玉米基地', url: 'https://sp.18yimu.com/#/' },
							{ name: '哈密国家农业科技园区', url: 'https://www.18yimu.com/hami/#/' },
							{ name: '璧山半朵云谷', url: 'https://www.18yimu.com/bdyg/#/' }
						]
					}
				],
				current: null
			}
		},
		created() {
			// 默认选中行情中心第一项「行情总览」
			this.current = this.marketList[0]
		},
		methods: {
          openUrl(item){
            if(item.url != '#'){
              window.open(item.url) 
            }else{
              this.current = item
            }
              
          },
			selectItem(item) {
				this.current = item
			},
			// 子页通过 $emit('nav', customName) 请求跳转到另一个 custom 子页（如首页“更多”→新闻资讯）
			handleNav(customName) {
				const find = list => {
					for (const it of list) {
						if (it.custom === customName) return it
						if (it.children) {
							const found = find(it.children)
							if (found) return found
						}
					}
					return null
				}
				const target = find(this.marketList)
				if (!target) return
				// 展开目标项所属的下拉分组
				this.marketList.forEach(g => {
					if (g.children && g.children.indexOf(target) !== -1) g.expanded = true
				})
				this.current = target
			},
			toggleGroup(item) {
				item.expanded = !item.expanded
			},
			isGroupActive(item) {
				return !!item.children && item.children.some(c => c === this.current)
			},
			isEmbeddable(url) {
				return !!url && url !== '#'
			}
		}
	}
</script>

<style scoped lang="scss">
	.origin-page {
		position: absolute;
		top: 82px;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		overflow: hidden;
	}

	/* 左侧列表 */
	.origin-side {
		flex: 0 0 220px;
		height: 100%;
		overflow-y: auto;
		overflow-x: hidden;
		padding: 20px 16px;
		box-sizing: border-box;
		border-right: 1px solid rgba(68, 193, 239, .3);
		background: rgba(12, 35, 85, .7);
		scrollbar-width: thin;
		scrollbar-color: rgba(68, 193, 239, .45) transparent;
	}

	/* 细滚动条，避免挤占菜单宽度 */
	.origin-side::-webkit-scrollbar {
		width: 4px;
		height: 4px;
	}

	.origin-side::-webkit-scrollbar-track {
		background: transparent;
	}

	.origin-side::-webkit-scrollbar-thumb {
		background: rgba(68, 193, 239, .45);
		border-radius: 4px;
	}

	.origin-side::-webkit-scrollbar-thumb:hover {
		background: rgba(68, 193, 239, .7);
	}

	.origin-side-title {
		margin-bottom: 20px;
		padding-left: 10px;
		font-size: 22px;
		font-weight: 400;
		color: #84d1ff;
		text-shadow: 0 0 10px rgba(73, 223, 255, .32);
		border-left: 3px solid #9bc74b;
	}

	.origin-group {
		margin-bottom: 22px;
	}

	.origin-group-title {
		margin-bottom: 12px;
		padding-left: 8px;
		font-size: 16px;
		font-weight: 600;
		color: #e6f4ff;
		border-left: 2px solid #44c1ef;
	}

	.origin-sub-title {
		margin: 10px 0 8px;
		font-size: 13px;
		color: #91c8ff;
		opacity: .85;
	}

	.origin-nav-item {
		margin-bottom: 8px;
		padding: 10px 12px;
		border: 1px solid rgba(68, 193, 239, .35);
		border-radius: 6px;
		background: linear-gradient(180deg, rgba(68, 193, 239, .12), rgba(12, 35, 85, .4));
		font-size: 15px;
		color: #e6f4ff;
		cursor: pointer;
		transition: all .25s ease;
	}

	.origin-nav-item:hover {
		border-color: #44c1ef;
		background: linear-gradient(180deg, rgba(68, 193, 239, .24), rgba(12, 35, 85, .55));
	}

	.origin-nav-item.active {
		border-color: #44c1ef;
		background: linear-gradient(180deg, rgba(68, 193, 239, .4), rgba(12, 35, 85, .6));
		color: #ffffff;
		box-shadow: 0 0 12px rgba(68, 193, 239, .35);
	}

	/* 可展开下拉分组 */
	.origin-group-toggle {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.origin-arrow {
		flex-shrink: 0;
		width: 6px;
		height: 6px;
		margin-left: 8px;
		border-right: 1.5px solid #91c8ff;
		border-bottom: 1.5px solid #91c8ff;
		transform: rotate(45deg);
		transform-origin: center center;
		transition: transform .25s ease;
	}

	.origin-arrow.open {
		transform: rotate(225deg);
	}

	.origin-sub-items {
		padding-left: 14px;
	}

	.origin-sub-item {
		padding: 8px 12px;
		font-size: 14px;
	}

	/* 右侧内嵌区域 */
	.origin-main {
		flex: 1;
		min-width: 0;
		height: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
	}

	.origin-main-head {
		flex: 0 0 auto;
		margin-bottom: 12px;
		padding-left: 8px;
		font-size: 18px;
		font-weight: 600;
		color: #e6f4ff;
		border-left: 2px solid #44c1ef;
	}

	.origin-frame {
		flex: 1;
		width: 100%;
		min-height: 0;
		border: 1px solid #3b88e8;
		border-radius: 8px;
		background: rgba(12, 35, 85, .94);
	}

	.origin-empty {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid rgba(68, 193, 239, .35);
		border-radius: 8px;
		font-size: 18px;
		color: #91c8ff;
	}
</style>
